module.exports = __webpack_public_path__ + "static/img/kefuImg.47552a54.jpg";